module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/refresh-082aae0541bd30e9a47858970b05420f.svg";